import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from "pinia";
import ModalOverlay from "#src/components/ModalOverlay.vue";

import { useLoginStore } from "#src/store.js";
import { useStatsStore } from "#src/store-pyr.js";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  emits: {
    hide: null,
},
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { userInfo, cellsSubmitted } = useStatsStore();
const { sessions } = storeToRefs(useLoginStore());

const emit = __emit;

const __returned__ = { userInfo, cellsSubmitted, sessions, emit, ModalOverlay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})